import React, { Component, Fragment } from "react";
import {
  Input,
  FormGroup,
  Label,
  Popover,
  PopoverBody,
  CustomInput,
  Button,
  Tooltip,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Alert
} from "reactstrap";
import { Colxx } from "../../components/common/CustomBootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CustomSelect from "./CustomSelect"
import Editor from "./Editor"
import CustomImage from "./CustomImage"
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import CustomDropzone from "./CustomDropZone";
import moment from "moment";
import {isAndroidOrIos} from "../../helpers/Utils"
import { SliderTooltip } from '../common/SliderTooltips';
import AppLocale from "../../config/lang";
import CustomSortable from "./CustomSortable";
import { NotificationManager } from "../../components/common/react-notifications"

class Field extends Component {
  constructor(props) {
    super(props);
    // console.log(props.value)
    let value = props.value
    if (props.opts && props.opts.default && (value === null || value === "")) {
      value = typeof props.opts.default === 'function' ? props.opts.default() : props.opts.default
      props.onChange(value)
    }
    this.state = { pop: false, tooltipId: props.name.replace('(', '').replace(')', '').replace(/\./g, '') };
    this.state[props.name] = ['date', 'time', 'datetime'].indexOf(props.type) > -1 
      ? (value ? moment(value).utcOffset(-5, true).local() : null)
      : value
    this.state.highlightDates = undefined
    this.state.includeDates = undefined
    this.state.tooltipOpen = false
    this.state[this.getRawDateInputKey(props.name)] = undefined
    this.datePickerRef = React.createRef()
  }

  getRawDateInputKey = (name = this.props.name) => `${name}_rawDateInput`

  getDatePickerDisplayFormat = () => {
    const { type, opts } = this.props
    if (opts && opts.dateFormat) return opts.dateFormat
    if (type === 'datetime') return 'YYYY/MM/DD HH:mm'
    if (type === 'time') return 'HH:mm'
    return 'YYYY/MM/DD'
  }

  getDateOutputFormat = () => ['datetime', 'time'].indexOf(this.props.type) > -1 ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD'

  componentDidUpdate(prevProps) {
    // necesario para actualizar los values de los componentes hijos
    // if (prevProps.value !== this.props.value) this.setState({ [this.props.name]: this.props.value });
    if (prevProps.value !== this.props.value) this.setState({
      [this.props.name]: ['date', 'time', 'datetime'].indexOf(this.props.type) > -1 
        ? (this.props.value ? moment(this.props.value).utcOffset(-5, true).local() : null)
        : this.props.value,
      [this.getRawDateInputKey()]: undefined
    }, () => {
      if (this.props.type === 'date' && !this.state[this.props.name] && this.props.opts && this.props.opts.onOpen) this.setState({ 
        highlightDates: undefined,
        includeDates: undefined
      })
    });
  }

  handleChange = value => {
    var val;
    val = this.props.opts && !!this.props.opts.negate ? !value : value;
    this.setState({ [this.props.name]: val }, () => {
      if (this.props.params) this.props.onChange({value: val, params: this.props.params})
      else this.props.onChange(val)
    });
  };

  handleDatePickerChange = value => {
    let format = this.getDateOutputFormat()
    let date = value ? moment(value).utcOffset(-5, false).format(format) : null;
    this.setState({ [this.props.name]: value, [this.getRawDateInputKey()]: undefined }); // cambiar estado local
    this.props.onChange(date); // enviar al componente padre --> Formcustom
  };

  handleDatePickerRawChange = (e) => {
    const rawValue = e && e.target ? e.target.value : ''
    this.setState({ [this.getRawDateInputKey()]: rawValue })
  }

  handleDatePickerBlur = (e) => {
    const rawInputKey = this.getRawDateInputKey()
    const rawValue = this.state[rawInputKey]

    if (rawValue !== undefined && rawValue !== null) {
      const trimmedRawValue = rawValue.trim()

      if (!trimmedRawValue) {
        this.setState({ [this.props.name]: null, [rawInputKey]: undefined }, () => {
          this.props.onChange(null)
        })
      } else {
        const displayFormat = this.getDatePickerDisplayFormat()
        const outputFormat = this.getDateOutputFormat()
        const parsedDate = moment(trimmedRawValue, [displayFormat, outputFormat], true)

        // Keep user typed text when it is not parseable yet, instead of reverting to last selected date.
        if (parsedDate.isValid()) {
          const parsedValue = parsedDate
          this.setState({ [this.props.name]: parsedValue, [rawInputKey]: undefined }, () => {
            this.props.onChange(moment(parsedValue).utcOffset(-5, false).format(outputFormat))
          })
        }
      }
    }

    this.handleBlur(e)
  }

  handleFieldChange = (e) => {
    let val = e.target.value
    this.setState({ [this.props.name]: val }, () => {
      if (this.props.params) this.props.onChange({value: val, params: this.props.params})
      else this.props.onChange(val)
    });
  }

  handleTagChange = tags => {
    this.setState({ [this.props.name]: tags });
    this.props.onChange(tags)
  };

  handleCheckboxGroupChange = (e) => {
    let newArray = this.state[this.props.name]
    let index = newArray.indexOf(e.target.value)
    if (index > -1) newArray.splice(index, 1)
    else newArray.push(e.target.value)
    this.setState({ [this.props.name]: newArray });
    this.props.onChange(newArray)
  }

  handleFocus = (e) => {
    if(!this.props.onFocus) return
    this.props.onFocus({
      value: this.state[this.props.name],
      params: this.props.params
    })
  }

  handleDatePickerOpen = () => {
    // suport touch backdrop mobile
    document.addEventListener('touchstart', function(event) {
      event.stopPropagation()
    }, true)
    if(!this.props.opts || !this.props.opts.onOpen) return
    this.props.opts.onOpen(this.props.ctx, this)
  }

  handleBlur = (e) => {
    if(!this.props.onBlur) return
    this.props.onBlur({
      value: this.state[this.props.name],
      params: this.props.params
    })
  }

  handleOnKeyUp = (e) => {
    // console.log(e.target.value)
    if(this.props.onKeyUp) this.props.onKeyUp(e, this)
  }

  handleOnKeyPress = (e) => {
    // console.log(e.target.value)
    if(this.props.onKeyPress) this.props.onKeyPress(e)
  }

  handleChangeQuill = (textQuillStandart) => {
    let val = textQuillStandart
    this.setState({ [this.props.name]: val }, () => {
      if (this.props.params) this.props.onChange({value: val, params: this.props.params})
      else this.props.onChange(val)
    });
  }

  handleChangeJodit = (val) => {
    // console.log('guardo')
    this.setState({ [this.props.name]: val }, () => {
      this.props.onChange(val)
    });
  }

  onTooltipClick() {
    if (this.props.opts && this.props.opts.tooltip && this.props.onTooltip) this.props.onTooltip({ name: this.props.label || this.props.hint, value: this.props.name });
  }

  toggleTooltip = () => {
    this.setState(prevState => ({
      tooltipOpen: !prevState.tooltipOpen
    }));
  };

  customDatePickerInput = React.forwardRef(({ value, onClick }, ref) => (
    <input type="button" value={value} onClick={onClick} ref={ref} style={{textAlign: "left"}}/>
  ))

  customAddon = (props) => {
    const L = AppLocale[this.props.locale]?.messages
    const {addon, type} = props
    const {buttons, texts} = addon
    
    return <InputGroupAddon addonType={type}>
      {buttons?.map((b, i) => {
        const isDisabled = typeof b.disabled === "function" ? b.disabled(this) : b.disabled
        const isOutline = typeof b.outline === 'function' ? b.outline() : !!b.outline
        const show = b.renderIf ? b.renderIf() : true
        return show ? <Button
          key={i}
          type="button"
          disabled={isDisabled}
          className={b.className?? ""}
          outline={isOutline}
          color={isDisabled ? "disabled" : "primary"}
          onClick={b.onClick ? () => { b.onClick(this.props.ctx) } : () => {}}>
            {L[b.name]?? b.name} {b.icon ? <i className={b.icon}></i> : ""}
        </Button> : ""
      })}

      {texts?.map((text, i) => {return <InputGroupText key={i}>{L[text]?? text}</InputGroupText>})}
    </InputGroupAddon>
  }

  // Add this new method to handle clear button click
  handleClearField = () => {
    console.log('Clear button clicked for field:', this.props.name)
    this.setState({ [this.props.name]: '' }, () => {
      this.props.onChange('')
    })
  }

  render() {
    const {
      col, colxs, offset, name, type, label, hint, validate, opts, onClick, disabled, placeholder, maxLength, tabIndex,
      className, idParent, locale, aiAssist, autoComplete, id, clearable
    } = this.props

    const L = AppLocale[locale]?.messages
    const rawDateInputValue = this.state[this.getRawDateInputKey()]
    
    // Debug logging
    // console.log('Field render:', { name, type, clearable, value: this.state[name], hasValue: this.state[name] && this.state[name].length > 0 })
    
    return (
      <Colxx sm={{size: col?? 3, offset: offset }} xxs={{size: colxs}} xs={{size: colxs}} className={'fadeIn ' + (type === 'hidden' ? 'd-none ' : '') + (opts?.colClassName?? '')}>
        <FormGroup className={opts?.wrapperClassName?? ''}>
          {hint &&
            <div
              className="mb-2 pointer"
              onClick={e => this.onTooltipClick()}
              onMouseEnter={e => this.setState({ pop: true })}
              onMouseLeave={e => this.setState({ pop: false })}
            >
              {hint}
              {opts && opts.tooltip &&
                <div id={this.state.tooltipId} className="help">
                  <Popover
                    placement="top-start"
                    isOpen={this.state.pop}
                    target={this.state.tooltipId}
                  >
                    <PopoverBody>Click to learn more about this feature!</PopoverBody>
                  </Popover>
                </div>
              }
            </div>
          }

          {['text', 'textarea', 'password', 'select', 'date', 'time', 'datetime', 'number', 'tel'].indexOf(type) >= 0 &&
            <Label className={`${opts?.style === 'float-label' ? 'has-float-label' : 'd-block'}`} onClick={e => e.preventDefault()}>{/* evento onclick para que se cierre automaticamente el datepicker luego de seleccionar*/}

              {aiAssist &&
                <div className="wrap-btn-ai-assist">
                  <Button type="button" color="light" id="tooltip-aiAssist" onClick={() => { this.props.onClickAiAssist(this.props) }}>AI</Button>
                  <Tooltip
                    placement="left"
                    isOpen={this.state.tooltipOpen}
                    target={"tooltip-aiAssist"}
                    toggle={this.toggleTooltip}
                  >
                    AI Writing Assistant
                  </Tooltip>
                </div>
              }

              {((!opts || (opts && !opts.style)) && label) && <div className="mb-2" dangerouslySetInnerHTML={{ __html:label}}></div>}

              {opts && opts.style === 'float-label' && label && <span>{label}</span>}
              <InputGroup className={opts?.inputWrapperClassName?? ''}>
                {opts?.addon?.prepend && <this.customAddon addon={opts.addon.prepend} type={"prepend"}></this.customAddon>}
                  {
                    type === 'date' || type === 'time' || type === 'datetime' ? (
                      <DatePicker
                        id={id?? `${idParent}-${name}`}
                        name={name}
                        locale={locale === 'es' ? 'es-ES' : 'en_US'}
                        placeholderText={placeholder?? ''}
                        selected={this.state[name]}
                        value={rawDateInputValue !== undefined ? rawDateInputValue : undefined}
                        onChange={this.handleDatePickerChange}
                        onChangeRaw={this.handleDatePickerRawChange}
                        onBlur={this.handleDatePickerBlur}
                        dateFormat={
                          opts && opts.dateFormat ? opts.dateFormat
                            : (type === 'datetime' ? 'YYYY/MM/DD HH:mm' : type === 'time' ? 'HH:mm' : 'YYYY/MM/DD')
                        }
                        timeFormat="HH:mm"
                        showTimeSelect={type === 'time' || type === 'datetime'}
                        showTimeSelectOnly={type === 'time'}
                        timeIntervals={opts && opts.timeIntervals ? opts.timeIntervals : 60}
                        timeCaption={locale === 'es' ? 'Hora' : 'Hour'}
                        minTime={opts?.minTime ? typeof opts.minTime === "function" ? opts.minTime(this.props.ctx) : opts.minTime : undefined}
                        maxTime={opts?.maxTime ? typeof opts.maxTime === "function" ? opts.maxTime(this.props.ctx) : opts.maxTime : undefined}
                        minDate={opts?.minDate ? typeof opts.minDate === "function" ? opts.minDate(this.props.ctx) : opts.minDate : undefined}
                        maxDate={opts?.maxDate ? typeof opts.maxDate === "function" ? opts.maxDate(this.props.ctx) : opts.maxDate : undefined}
                        startDate={opts?.startDate?.(this.props.ctx) ?? undefined}
                        endDate={opts?.endDate?.(this.props.ctx) ?? undefined}
                        selectsStart={!!opts?.selectsStart}
                        selectsEnd={!!opts?.selectsEnd}
                        isClearable={disabled ? false : true}
                        autoComplete="off"
                        highlightDates={this.state.highlightDates}
                        includeDates={this.state.includeDates}
                        onCalendarOpen={this.handleDatePickerOpen}
                        disabled={disabled}
                        ref={this.datePickerRef}
                        withPortal={isAndroidOrIos()}
                        customInput={isAndroidOrIos() ? <this.customDatePickerInput/> : null}
                        // onMonthChange={(e) => { console.log(e) }}
                      />
                    ) : type === 'select' ? (
                      <CustomSelect
                        id={id?? `${idParent}-${name}`}
                        name={name}
                        value={this.state[name]}
                        placeholder={placeholder?? 'Select..'}
                        items={opts ? (opts.itemsF ? opts.itemsF(this.props.ctx, this) : opts.items) : null}
                        path={opts ? opts.path : null}
                        withImg={opts ? opts.withImg : null}
                        withIcon={opts?.withIcon}
                        isMulti={opts ? opts.isMulti : null}
                        searchOnline={opts ? opts.searchOnline : null}
                        onChange={this.handleChange}
                        onFocus={this.handleFocus}
                        onBlur={this.handleBlur}
                        remap={opts ? opts.remap : null}
                        setOutput={opts ? opts.setOutput : null}
                        isClearable={opts ? (opts.isClearable === undefined ? true : opts.isClearable) : true}
                        disabled={disabled}
                        tabIndex={tabIndex}
                        filterOption={opts ? opts.filterOption : null}
                        parentValue={this.props.parentValue}
                        onMenuOpen={opts ? opts.onMenuOpen : null}
                        listInLocalStorage={opts ? opts.listInLocalStorage : null}
                        ctx={this.props.ctx}
                        getValueLabelOfFieldSelect={this.props.getValueLabelOfFieldSelect}
                      />
                    ) : (type === 'text' || type === 'textarea' || type === 'password' || type === 'number' || type === 'tel') ? (
                      <div className="position-relative w-100">
                        <Input
                          id={id?? `${idParent}-${name}`}
                          name={autoComplete ? name : `${name}_${Date.now()}`}
                          type={type}
                          disabled={disabled}
                          value={this.state[name]?? ''}
                          onKeyUp={this.handleOnKeyUp}
                          onKeyPress={this.handleOnKeyPress}
                          onChange={this.handleFieldChange}
                          onFocus={this.handleFocus}
                          onBlur={this.handleBlur}
                          onClick={onClick ? onClick : () => { }}
                          placeholder={placeholder?? ''}
                          maxLength={maxLength || '10000'}
                          tabIndex={tabIndex}
                          rows={opts && opts.rows ? opts.rows : '3'}
                          className={`${className?? ""} ${aiAssist ? "input-ai-assist" : ""} ${clearable ? 'pr-5' : ''}`}
                          autoComplete={autoComplete ? "on" : "new-password"}
                        />
                        {clearable && this.state[name] && this.state[name].toString().length > 0 && (
                          <button
                            type="button"
                            className="position-absolute"
                            style={{
                              right: '0.75rem',
                              top: '55%',
                              transform: 'translateY(-50%)',
                              background: 'none',
                              border: 'none',
                              cursor: 'pointer',
                              padding: '0',
                            }}
                            onClick={this.handleClearField}
                          >
                            <svg
                              height="20"
                              width="20"
                              viewBox="0 0 20 20"
                              aria-hidden="true"
                            >
                              <path
                                d="M14.348 14.849c-.469.469-1.229.469-1.697 0L10 11.819l-2.651 3.029c-.469.469-1.229.469-1.697 0-.469-.469-.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-.469-.469-.469-1.228 0-1.697.469-.469 1.228-.469 1.697 0L10 8.183l2.651-3.031c.469-.469 1.228-.469 1.697 0 .469.469.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c.469.469.469 1.229 0 1.698z"
                                fill="currentColor"
                              />
                            </svg>
                          </button>
                        )}
                      </div>
                    ) : ('')
                  }
                {opts?.addon?.append && <this.customAddon addon={opts.addon.append} type={"append"}></this.customAddon>}
              </InputGroup>
              {/* Validation message */}
              {validate}
            </Label>
          }

          {type === 'label' &&
            <Fragment>
              <div 
                id={id?? `${idParent}-${name}`} 
                className="label" 
                dangerouslySetInnerHTML={{ __html:L[this.state[name]]?? this.state[name]}}>
              </div>
              {validate}
            </Fragment>
          }

          {type === 'image' &&
            <div
              style={{ backgroundImage: "url(" + this.state[name] + "),url(" + (opts && opts.backgroundImage ? opts.backgroundImage : '') + ")" }}
              className="imgPlaceholder">
            </div>
          }

          {type === 'button' &&
            <div className="h-100 d-flex align-items-center">
              {opts?.labelBeforeButton && <label className="my-0 mr-3">{L[opts.labelBeforeButton]?? opts.labelBeforeButton}</label>}
              <Button
                style={{marginTop: '6px'}}
                type="button"
                size="sm"
                color={!disabled ? opts?.kind ? opts.kind : 'primary' : 'disabled'}
                outline={opts?.outline}
                disabled={disabled}
                onClick={onClick ? onClick : () => { }}
                className={className}
              >
                <i className={opts?.icon?? ''} style={opts?.iconStyle?? {}}></i> {label}
              </Button>
            </div>
          }

          {type === 'switch' &&
            <div className="d-flex align-items-center">
              <Switch
                className="custom-switch custom-switch-primary"
                checked={opts && !!opts.negate ? !this.state[name] : this.state[name]}
                onChange={this.handleChange}
                disabled={disabled}
              />
              {label && <div className="title-field mt-0 mb-0 ml-2">{label}</div>}
            </div>
          }

          {type === 'file' &&
            <CustomImage
              name={name}
              opts={opts}
              value={this.state[name]}
              onChange={this.handleChange}
            />
          }

          {type === 'dropzone' &&
            <Fragment>
              {label && <div className="title-field" dangerouslySetInnerHTML={{ __html:label}}></div>}
              <CustomDropzone
                id={`${idParent}-${name}`}
                name={name}
                placeholder={placeholder}
                opts={opts}
                value={this.state[name]}
                onChange={this.handleChange}
                uploadFiles={this.props.uploadFiles}
                disabled={disabled}
              />
              {validate}
            </Fragment>
          }

          {type === 'embed' &&
            <iframe
              id={`${idParent}-${name}`}
              title={name}
              frameBorder={0}
            ></iframe>
          }

          {type === 'tag' &&
            <Fragment>
              {label && <Label>{label}</Label>}
                <TagsInput
                  className={'react-tagsinput ' + (disabled ? 'react-tagsinput--disabled ' : '')}
                  value={this.state[name]}
                  onChange={this.handleTagChange}
                  inputProps={{ placeholder: placeholder, enterkeyhint: "go"}}
                  disabled={disabled}
                  addKeys={opts?.addKeys || [9, 13]}
                  validationRegex={opts?.validationRegex || /.*/}
                  onValidationReject={(r) => {
                    if (r) {
                      const msg = `${L["main.invalidTag"]}: ${r[0]}`
                      NotificationManager.error((L[opts?.msgInvalidTag] ?? opts?.msgInvalidTag) || msg, "", 4000, null, null, "outline")
                    }
                  }}
                />
                {validate}
            </Fragment>
          }

          {type === 'checkbox' &&
            <Fragment>
              <CustomInput
                id={`${idParent}-${name}`}
                type="checkbox"
                name={name}
                value={this.props.value}
                label={label}
                disabled={disabled}
                onChange={this.handleFieldChange}
              />
              {validate}
            </Fragment>
          }

          {type === 'checkboxGroup' &&
            <Fragment>
              {label && <Label>{label}</Label>}
              <div>
                {opts.list.map((e, i) => {
                  return (
                    <CustomInput
                      type="checkbox"
                      key={i}
                      id={name + i}
                      name={name}
                      value={e.value}
                      label={e.label}
                      inline={opts.inline}
                      checked={this.state[name].indexOf(e.value) > -1}
                      onChange={this.handleCheckboxGroupChange}
                      disabled={disabled}
                    />
                  )
                })}
              </div>
              {validate}
            </Fragment>
          }

          {type === 'radio' &&
            <Fragment>
              <div className="custom-radio custom-control">
                <input
                  id={`${idParent}-${name}`}
                  type="radio"
                  className="radio-button-absolute custom-control-input pointer"
                  checked={this.props.checked}
                  value={opts.value}
                  disabled={disabled}
                  onChange={this.handleFieldChange}
                  onClick={this.props.onClick ? () => { this.props.onClick(this) } : () => {}}
                />
                <label className="custom-control-label d-flex" htmlFor={name}>
                  {opts.img && <div className="mr-2">
                    <img alt="" src={opts.img} onError={(e) => { e.target.onerror = null; e.target.src = require("../../assets/img/doc.png") }} width={"60px"}/>
                  </div>}
                  <div>
                    <div className="text-one">{label}</div>
                    <div className="text-muted text-small">{L[opts?.desc]?? opts?.desc}</div>
                  </div>
                </label>
              </div >
              {validate}
            </Fragment>
          }

          {type === 'radioGroup' &&
            <Fragment>
              {label && <Label>{label}</Label>}
              <div>
                {opts.list.map((e, i) => {
                  return (
                    <CustomInput
                      type="radio"
                      key={i}
                      id={name + i}
                      name={name}
                      value={e.value}
                      label={L[e.label]?? e.label}
                      inline={opts.inline}
                      checked={e.value === this.state[name]}
                      onChange={this.handleFieldChange}
                      disabled={disabled}
                    />
                  )
                })}
              </div>
              {validate}
            </Fragment>
          }
          
          {type === 'editor' &&
            <Fragment>
              {label && <Label>{label}</Label>}
              <Editor
                id={`${idParent}-${name}`}
                name={name}
                value={this.state[name]}
                placeholder={placeholder}
                onChange={this.handleChangeJodit}
                disabled={disabled}
                aiAssist={aiAssist ? (editor) => { this.props.onClickAiAssist(this.props, editor) } : null}
              />
              {validate}
            </Fragment>
          }

          {type === 'slider' &&
            <Fragment>
              <SliderTooltip
                value={this.state[name]}
                min={opts?.slider?.min}
                max={opts?.slider?.max}
                defaultValue={this.state[name]}
                className="mb-5"
                step={opts?.slider?.step}
                onChange={this.handleChange}
              />
              {validate}
            </Fragment>
          }

          {type === 'separator' &&
            <div></div>
          }

          {type === 'select2' &&
            <div>Select</div>
          }

          {type === 'alert' &&
            <Alert color={opts?.color?? "info"}>{L[this.state[name]]?? this.state[name]}</Alert>
          }

          {type === 'sortable' &&
            <Fragment>
              {validate}
              <CustomSortable
                value={this.state[name]}
                onChange={this.handleTagChange}
                placeholder={placeholder}
                nameButton={opts?.nameButton}
                L={L}
              ></CustomSortable>
            </Fragment>
          }

          {type === 'component' && <opts.component form={this.props.ctx.state} L={L}></opts.component>}
        </FormGroup>
      </Colxx>
    );
  }
};

export default Field;